/** @param {(sample: { name: string, value: number, unit?: string }) => void} report */
export function observeFID(report) {
  try {
    const obs = new PerformanceObserver((list) => {
      for (const entry of list.getEntries()) {
        report({ name: 'FID', value: entry.processingStart - entry.startTime, unit: 'ms' })
      }
    })
    obs.observe({ type: 'first-input', buffered: true })
    return () => obs.disconnect()
  } catch {
    return () => {}
  }
}

/** @param {(sample: { name: string, value: number, unit?: string }) => void} report */
export function observeCLS(report) {
  try {
    let cls = 0
    const obs = new PerformanceObserver((list) => {
      for (const entry of list.getEntries()) {
        if (!entry.hadRecentInput) cls += entry.value
      }
      report({ name: 'CLS', value: cls })
    })
    obs.observe({ type: 'layout-shift', buffered: true })
    return () => obs.disconnect()
  } catch {
    return () => {}
  }
}
